// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2W9yL","label":"Radio_label__381UH","checkMark":"Radio_checkMark__9ln_9","disabled":"Radio_disabled__f5kW5"};